import React from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { reorderWeekdayDependentLanguage } from './helper';
import WeekDay from './WeekDay';
import Box from '../../../elements/Box';

export default function WeekDayNames(props: any) {
  const { localizationData } = React.useContext(Context);
  const weekdays = reorderWeekdayDependentLanguage(localizationData);
  return (
    <Box className="calendar-days-title" role="row" {...props.weekDaysContainer}>
      {weekdays.map((offset) => {
        return <WeekDay key={`weekday-${offset}`} weekday={offset} {...props.weekdayItem} />;
      })}
    </Box>
  );
}
